<app-navbar></app-navbar>
<div class="register-page-content container">
  <!-- tabs -->
  <ul
    class="flex-row flex-sm-row my-4 nav nav-pills nav-fill user-types-list"
    role="tablist"
  >
    <li class="mx-1 nav-item">
      <a
        [ngClass]="{ active: selectedType === userTypes.MARKETER }"
        class="mb-md-0 mb-sm-3 nav-link fw-800"
        (click)="setRegisterType(userTypes.MARKETER)"
        >مسوق</a
      >
    </li>
    <li class="mx-1 nav-item">
      <a
        [ngClass]="{ active: selectedType === userTypes.CONTROLLER }"
        class="mb-md-0 mb-sm-3 nav-link fw-800"
        (click)="setRegisterType(userTypes.CONTROLLER)"
        >مراقب</a
      >
    </li>
  </ul>

  <div class="container">
    <div class="justify-content-center row">
      <div class="col-lg-5">
        <div class="login-card">
          <div class="bg-white pb-5 card-header">
            <div class="login-img">
              <div class="login-img_container">
                <img src="assets/img/logo.png" alt="kharaaj" />
              </div>
            </div>
          </div>

          <div class="mt-1 px-lg-5 py-lg-5 card-body">
            <div class="text-login text-muted text-right">
              <div class="text-login_welcome">مرحباً بك</div>
              <div class="text-login_desc">
                <small>البورصة الزراعية أول منصة لبيع المنتجات</small>
                <small>الزراعية بالجملة فالمنطقة</small>
              </div>
            </div>

            <!-- login form -->
            <form
              class="login-form"
              role="form"
              [formGroup]="loginForm"
              (submit)="onSubmit()"
            >
              <!-- controller -->
              <div
                *ngIf="selectedType === userTypes.CONTROLLER"
                class="form-group mb-3"
              >
                <div class="input-group input-group-alternative">
                  <label class="login-form_phone-code">{{ phoneCode }}</label>
                  <input
                    formControlName="phoneNumber"
                    class="form-control"
                    placeholder="إدخال رقم الهاتف"
                    pattern="\d*"
                    [maxlength]="phoneLength"
                    type="tel"
                  />
                </div>
              </div>

              <!-- marketer -->
              <div
                *ngIf="selectedType === userTypes.MARKETER"
                class="form-group mb-3"
              >
                <div
                  class="btn-group btn-group-toggle float-right my-2"
                  data-toggle="buttons"
                >
                  <label
                    (click)="selectCode()"
                    [ngClass]="{ active: isCodeSelected }"
                    class="mx-2 btn"
                  >
                    <input type="radio" autocomplete="off" /> رقم الإقتران
                  </label>

                  <label
                    (click)="selectPhone()"
                    [ngClass]="{ active: isPhoneSelected }"
                    class="mx-2 btn"
                  >
                    <input type="radio" autocomplete="off" /> رقم الهاتف
                  </label>
                </div>

                <!-- pairing code -->
                <div
                  class="input-group input-group-alternative"
                  *ngIf="isCodeSelected"
                >
                  <input
                    formControlName="pairingCode"
                    class="form-control"
                    placeholder="رقم الإقتران"
                    type="text"
                  />
                </div>

                <!-- phone -->
                <div
                  class="input-group input-group-alternative"
                  *ngIf="isPhoneSelected"
                >
                  <label class="login-form_phone-code">{{ phoneCode }}</label>
                  <input
                    formControlName="phoneNumber"
                    class="form-control"
                    placeholder="إدخال رقم الهاتف"
                    pattern="\d*"
                    [maxlength]="phoneLength"
                    type="tel"
                  />
                </div>
              </div>

              <!-- password (both) -->
              <div
                *ngIf="
                  selectedType === userTypes.CONTROLLER ||
                  selectedType === userTypes.MARKETER
                "
                class="form-group mb-3"
              >
                <div class="input-group input-group-alternative">
                  <input
                    formControlName="pwd"
                    class="form-control"
                    placeholder="كلمة المرور"
                    type="password"
                  />
                </div>
                <br />
                <a routerLink="/auth/forget-password">
                  <label>نسيت كلمة السر؟</label>
                </a>
              </div>

              <div class="text-center login-form_bottom">
                <button
                  type="submit"
                  class="my-4 btn btn-primary"
                  [disabled]="loginForm.invalid"
                >
                  تسجيل الدخول
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
